import paths from "@ingka/icons-shared/paths/checkmark-green-small";
import { renderPaths } from "../renderPaths.mjs";
var checkmark_green_small_default = () => renderPaths(paths);
export {
  checkmark_green_small_default as default
};
